import { observer } from 'mobx-react-lite';
import { Form, Select } from 'semantic-ui-react';

function DropdownCommon({
  name,
  placeholder,
  value,
  options,
  onChange,
}: {
  name: string;
  placeholder: string;
  value: string;
  options: any;
  onChange: (val: string) => void;
}) {
  return (
    <div style={{ marginTop: '16px' }}>
      <h4>{name}</h4>
      <Form.Field
        control={Select}
        placeholder={placeholder}
        clearable
        fluid
        search
        selection
        options={options}
        onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
          if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
            e.stopPropagation();
        }}
        style={{ marginTop: '5px' }}
        value={value}
        onChange={(_e: any, data: any) => onChange(data.value)}
      />
    </div>
  );
}

export default observer(DropdownCommon);
